import React from "react";
//import Modal from 'react-bootstrap4-modal';
import Modal from "react-bootstrap/es/Modal";

class AlertModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true
    }
  }
  close= () => {
    this.setState({
      visible : false
    });
  }
  render() {
    const showModel = this.props.showModal;
    return (
        <div className="static-modal">
          <Modal className="alertModal"  animation={false} show={this.state.visible} onHide={this.close}>
            {/*<Modal.Header closeButton> </Modal.Header>*/}
            <Modal.Body>
              <div style={{ paddingTop: "35px", paddingLeft: "35px", paddingRight: "35px" }}>
                {/*<h3>Planned Service Interruptions</h3>
                        <div style={{ paddingTop: "20px" }}></div>
                        <p>Our service will be unavailable due to scheduled maintenances:</p>
                        <div style={{ paddingTop: "10px" }}></div>
                        <p><b>Date: Saturday, November 16th to Sunday, November 17th</b></p>
                        <p><b>Timing: Approximately 12:00 PM (ET) Saturday to Sunday Afternoon</b></p>
                        <div style={{ paddingTop: "10px", paddingBottom: "10px", borderTop: "1px dotted black" }}></div>
                        <p><b>Date: Sunday, November 24th</b></p>
                        <p><b>Timing: Approximately 1:00 PM (ET) to 5:00 PM (ET)</b></p>*/}
                {/*<h3>Planned Service Interruption</h3>
                <div style={{ paddingTop: "20px" }}></div>
                <p>Our service will be unavailable due to scheduled maintenance:</p>
                <div style={{ paddingTop: "10px" }}></div>
                <p><b>Date: 11/23/24 (Saturday) morning to 11/24/24 (Sunday) afternoon</b></p>*/}
                {/*<h3>Service Interruption</h3>
                <p>We are currently experiencing a service interruption due to a regional outage.</p>
                <div style={{ paddingTop: "10px" }}></div>
                <p><b>Expected restoration time: January 9, 2025 3:30 AM</b></p>
                <div style={{ paddingTop: "10px" }}></div>
                <p>We apologize for any inconvenience this may cause. </p>*/}
                <p>Service interrupted due to regional outage. Will be restored shortly. We apologize for any inconvenience.</p>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button type="button" className="btn btn-primary btn-sm" onClick={this.close}>
                Close
              </button>
            </Modal.Footer>
          </Modal>
        </div>

    );
  }
}

export default AlertModal;



// WEBPACK FOOTER //
// ./src/layout/AlertModal.js